// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1678":"8506dbe6","8231":"76e3c270"}[chunkId] + ".chunk.css";
};